// extracted by mini-css-extract-plugin
module.exports = {"page-header":"index_page-header__32GNt","breadcrumb":"index_breadcrumb__FCmM1","header-title":"index_header-title__14awQ"};